// extracted by mini-css-extract-plugin
export var externalLink = "_b8-0";
export var internalLinkLabel = "_b8-1";